import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Auth from './lessonPlayer/services/AuthService';
import { API_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE } from './api-config';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const logo = null; // TODO: get a real logo
Auth.init(API_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE, logo);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
